import { Controller } from "@hotwired/stimulus";

// Replaces the old jQuery fancybox-based step1-timer dialog (session
// timeout warning -- prices are no longer guaranteed after 20 minutes).
// Matches the original's forced-refresh semantics: however this dialog
// closes (backdrop click, the X, or the renew button itself), it always
// triggers a fresh search via the real "Sök flyg" submit button
// (.main_btn_wide, still a real <input type=submit> on the rebuilt
// searchfield -- see the comment on that class in
// _search_field_return.html.erb) -- there's no way to just dismiss this
// and keep looking at stale results, by design.
export default class extends Controller {
  static targets = ["overlay", "renewButton", "spinner"];
  static values = { timeoutAt: Number };

  connect() {
    const timeLeft = this.timeoutAtValue - Date.now();
    this.timer = setTimeout(() => this.open(), Math.max(timeLeft, 0));
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  open() {
    this.overlayTarget.classList.remove("hidden");
    this.overlayTarget.classList.add("flex");
  }

  renewAndClose() {
    this.overlayTarget.classList.add("hidden");
    this.overlayTarget.classList.remove("flex");
    this.triggerSearch();
  }

  renew() {
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden");
    if (this.hasRenewButtonTarget) this.renewButtonTarget.disabled = true;
    this.triggerSearch();
  }

  triggerSearch() {
    const button = document.querySelector(".main_btn_wide");
    if (button) button.click();
  }
}
